import {
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

const KEYBOARD_OPTIONS = { coordinateGetter: sortableKeyboardCoordinates };

/** Pointer and keyboard drag sensors shared by the ViewTable, DataGrid and spreadsheet column settings lists. */
export const useColumnSettingsSensors = () =>
    useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, KEYBOARD_OPTIONS),
    );
